import { useEffect, useState } from 'react'
import { APP_TITLE, APP_HELP_TITLE_MAXLENGTH } from '../config/contants.config'

export default function useDocumentTitle(initialTitle?: string) {
    const [title, setTitle] = useState(initialTitle)
    useEffect(() => {
        if (title) {
            let isOverMaxLength = title.length + APP_TITLE.length - APP_HELP_TITLE_MAXLENGTH
            let validatedTitle = isOverMaxLength > 0 ? `${title.substring(0, title.length - isOverMaxLength)}...` : title
            document.title = `${validatedTitle} - ${APP_TITLE}`;
        } else {
            document.title = APP_TITLE
        }
        return () => {
            document.title = APP_TITLE
        }
    }, [title])
    return setTitle
}
